var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100px",
    height: "100px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t\t.avocado_een {\r\n\t\t\t\tfill: #4f4a4b;\r\n\t\t\t}\r\n\r\n\t\t\t.avocado_negen {\r\n\t\t\t\tfill: #6F9B45;\r\n\t\t\t}\r\n\r\n\t\t\t.avocado_tien {\r\n\t\t\t\tfill: #C3CC6A;\r\n\t\t\t}\r\n\r\n\t\t\t.avocado_drie {\r\n\t\t\t\tfill: #716558;\r\n\t\t\t}\r\n\r\n\t\t\t.avocado_vier {\r\n\t\t\t\tfill: #ccaa66;\r\n\t\t\t}\r\n\r\n\t\t\t.st0 {\r\n\t\t\t\tfill: #EAD13F;\r\n\t\t\t}\r\n\r\n\t\t\t.st1 {\r\n\t\t\t\tfill: #CC4121;\r\n\t\t\t}\r\n\r\n\t\t\t.st2 {\r\n\t\t\t\tfill: #FFFAEE;\r\n\t\t\t}\r\n\r\n\t\t\t.st3 {\r\n\t\t\t\tfill: #E0A838;\r\n\t\t\t}\r\n\r\n\t\t\t.st4 {\r\n\t\t\t\tfill: #D1712A;\r\n\t\t\t}\r\n\r\n\t\t\t.st5 {\r\n\t\t\t\tfill: #A3AEB5;\r\n\t\t\t}\r\n\r\n\t\t\t.st6 {\r\n\t\t\t\tfill: #788287;\r\n\t\t\t}\r\n\r\n\t\t\t.st7 {\r\n\t\t\t\tfill: #248EBC;\r\n\t\t\t}\r\n\r\n\t\t\t.st8 {\r\n\t\t\t\tfill: #8D3E93;\r\n\t\t\t}\r\n\r\n\t\t\t.st9 {\r\n\t\t\t\tfill: #3D3935;\r\n\t\t\t}\r\n\r\n\t\t\t.st10 {\r\n\t\t\t\tfill: #D36781;\r\n\t\t\t}\r\n\r\n\t\t\t.st11 {\r\n\t\t\t\tfill: #E598A3;\r\n\t\t\t}\r\n\r\n\t\t\t.st12 {\r\n\t\t\t\tfill: #DBD2C1;\r\n\t\t\t}\r\n\r\n\t\t\t.st13 {\r\n\t\t\t\tfill: #4f4a4b;\r\n\t\t\t}\r\n\t\t"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "avocado_tien",
    d: "M26.241,9.442c-0.061-0.167-0.796-0.56-3.433-0.371l-0.712,0.052l0.195-0.687 c0.887-3.12,0.602-4.102,0.433-4.2c-0.19-0.11-1.291,0.188-3.803,2.874l-0.665,0.711l-0.19-0.954C17.263,2.852,16.311,1.5,16,1.5 s-1.263,1.352-2.066,5.368l-0.19,0.954l-0.665-0.711c-2.517-2.691-3.617-2.982-3.803-2.874c-0.169,0.098-0.454,1.08,0.433,4.2 l0.195,0.687L9.191,9.072C6.557,8.883,5.82,9.275,5.759,9.442c-0.285,0.784,3.815,3.739,6.668,5.058h7.146 C22.426,13.182,26.526,10.226,26.241,9.442z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "avocado_negen",
    d: "M26.241,9.442c-0.016-0.043-0.078-0.1-0.202-0.159C23.495,11.257,19.95,12.5,16,12.5 c-3.95,0-7.495-1.243-10.039-3.217C5.837,9.342,5.775,9.4,5.759,9.442c-0.285,0.784,3.815,3.739,6.668,5.058h7.146 C22.426,13.182,26.526,10.226,26.241,9.442z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "avocado_vier",
    points: "23.5,27.5 22.434,27.5 23.559,18.5 24.5,18.5 24.5,14.5 7.5,14.5 7.5,18.5 8.441,18.5 9.566,27.5 8.5,27.5 8.5,30.5 23.5,30.5 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "avocado_drie",
    points: "23.396 19.763 8.62 19.763 8.438 18.536 23.708 18.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "avocado_drie",
    points: "22.44 27.586 9.585 27.543 9.544 27.319 22.473 27.362"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.d93f2f7dfca6d5ce623bc8ba6efa9922.svg";
export { ForwardRef as ReactComponent };